module.exports = __webpack_public_path__ + "img/shebei2.71f4b4da.png";